export default __webpack_public_path__ + "static/media/heimdallr.69de2150.svg";